<template>
  <div>
    <vue-apex-charts
      :key="key"
      v-if="stats"
      type="bar"
      :options="options"
      :series="series"
      :height="typeData === 'M' ? '350px' : '350px'"
    />
  </div>
</template>
<script>
  import {
    mapState
  } from 'vuex'
  import _ from 'lodash'
  import api from '@/services/api'
  import VueApexCharts from 'vue-apexcharts'
  export default {
    components: {
      VueApexCharts,
    },
    props: {
      stats: {
        type: Array,
        required: true
      },
      typeData: {
        type: String,
        required: true
      }
    },
    data: () => ({
      key: 0,
      options: {
        plotOptions: {
          bar: {
              barHeight: '80%',
            horizontal: true,
            dataLabels: {
              position: 'center', // top, center, bottom
            },
          }
        },
        colors: ['#123123'],
        dataLabels: {
            enabled: true,
            textAnchor: 'start',
            formatter: function (val) {
                return '  '.concat(val)
            },
            offsetX: -10,
            offsetY: 0,
            style: {
                fontSize: '12px',
                colors: ["#CCCCCC"]
            }
        },
        chart: {
          id: 'stats'
        },
        xaxis: {
          categories: []//[1991, 1992, 1993, 1994, 1995, 1996, 1997, 1998]
        },
        title: {
          text: '',
          align: 'center',
          floating: true
        },
        subtitle: {
            text: '',
            align: 'center',
        },
      },
      series: [{
        name: 'clicks',
        data: [] // [30, 40, 45, 50, 49, 60, 70, 91]
      }]
    }),
    computed: { 
      enterpriseColor() {
        return this.$store.state.app.enterpriseColor
      },
      enterpriseName() {
        return this.$store.state.app.enterpriseName
      },
      info () {
        return process.env.VUE_APP_INFOSORT
      }
    },
    watch: {
      'stats': {
        handler: function (newValue) {
          this.handleConvertStats(newValue)
        },
        deep: true
      },
    },
    mounted () {
      this.handleConvertStats(this.stats)
    },
    methods: {
      handleConvertStats (stats) {
        this.key = this.enterpriseName.concat('_', _.uniqueId())
        const auxData = []
        const auxCategories = []
        for (let i = 0; i < stats.length;i++) {
          auxData.push(stats[i].value)           
          auxCategories.push(stats[i].key)
        }
        this.series[0].data = auxData
        this.options.xaxis.categories = auxCategories
        this.options.colors =[`${this.enterpriseColor.substring(0,7)}`]
        this.options.title.text = this.$t('dashboard.stats.access').concat(this.enterpriseName)
        this.options.subtitle.text = this.info
      },
    }
  }
</script>
<style>
  .v-sheet--offset {
    top: -24px;
    position: relative;
  }
</style>
